import { render, staticRenderFns } from "./GatewayShow.vue?vue&type=template&id=13147c6f&"
import script from "./GatewayShow.vue?vue&type=script&lang=js&"
export * from "./GatewayShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports